module.exports = __webpack_public_path__ + "media/images/new_landing/people/michaela-ondrakova-0764736033050b51003aace36e8835e3.jpeg";